import DirectDepositScreen from 'features/directDeposit/screens/DirectDepositMenuScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function DirectDepositPage() {
  return (
    <PinwheelContextProvider>
      <DirectDepositScreen />
    </PinwheelContextProvider>
  );
}
